import React from "react";
import _ from "lodash";

export const b64DecodeUnicode = (str) => {
  let decodedString = decodeURIComponent(
    Array.prototype.map
      .call(
        atob(str),
        (c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      )
      .join("")
  );
  return decodedString;
};

export const parseJwt = (token) => {
  let str = b64DecodeUnicode(
    token.split(".")[1].replace("-", "+").replace("_", "/")
  );
  let parsed = JSON.parse(str);
  return parsed;
};

export const parseUserIdFromJwt = (token) => {
  let str = b64DecodeUnicode(
    token.split(".")[1].replace("-", "+").replace("_", "/")
  );
  let parsed = JSON.parse(str);
  return parsed.user_id;
};

export const saveLocalStorage = (key, values) => {
  const data = [];
  data.push(values);
  localStorage.setItem(key, JSON.stringify(data));
};

export const getLocalStorage = (key) => {
  const test = localStorage.getItem(key);
  const data = JSON.parse(localStorage.getItem(key));

  if (
    typeof data != "undefined" &&
    data != null &&
    typeof data[0] != "undefined"
  ) {
    if (key == "loginDetails") {
      return data[0].token;
    } else if (key == "userInfo") {
      return data[0].email;
    } else if (key == "role") {
      return data[0];
    } else if (key == "user_id") {
      return data[0];
    } else if (key == "userEmail") {
      return data[0].email;
    }
  }
  return [];
};

export const getToken = () => {
  if (!_.isEmpty(getLocalStorage("loginDetails")))
    return getLocalStorage("loginDetail").token;

  return "";
};

export const removeLocalStorage = (keys) => {
  if (typeof keys == "string") {
    localStorage.removeItem(keys);
  } else if (Array.isArray(keys) && keys.length > 0) {
    keys.map((key) => {
      localStorage.removeItem(key);
    });
  }
};

export const nonTxnEdit = (data) => {
  var txn_Noneditable = [];
  data.map((val, index) => {
    for (var key in val) {
      if (key == "0|is_error|is_error" || key == "0|txn_error|txn_error") {
        if (
          val[key] == 1 ||
          val[key] == 2 ||
          val[key] == 3 ||
          val[key] == 4 ||
          val[key] == 5 ||
          val[key] == 7 ||
          val[key] == 9 ||
          val[key] == 11 ||
          val[key] == 13 ||
          val[key] == 99
        ) {
          txn_Noneditable.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
    return val;
  });
  return txn_Noneditable;
};

export const nonTxnEwayBillEdit = (data) => {
  var txn_Noneditable = [],
    txn_NonSelect = [];
  data.map((val, index) => {
    for (var key in val) {
      if (
        key == "67|EwbDtlsDistance|Trans_Distance" ||
        key == "0|txn_error|txn_error" ||
        key == "0|all_is_srvc|all_is_srvc" ||
        key == "0|ew_status_cd|ew_status_cd"
      ) {
        if (
          val[key] == null ||
          val[key] == "" ||
          val[key] == undefined ||
          val[key] != "{}" ||
          val[key] == "Y"
        ) {
          txn_NonSelect.push(val["0|txn_id|Txn_id"]);
        } else if (val[key] == "1") {
          txn_NonSelect.push(val["0|txn_id|Txn_id"]);
          txn_Noneditable.push(val["0|txn_id|Txn_id"]);
        }
      }
      // if(key == '0|ew_status_cd|ew_status_cd'){
      //   if(val[key] == "1"){
      //     txn_NonSelect.push(val['0|txn_id|Txn_id'])
      //     txn_Noneditable.push(val['0|txn_id|Txn_id'])
      //   }
      // }
      // if(key == '0|txn_error|txn_error'){
      //   if(val[key] != "{}"){
      //     txn_NonSelect.push(val['0|txn_id|Txn_id'])
      //   }
      // }
      // if(key == '0|all_is_srvc|all_is_srvc'){
      //   if(val[key] == "Y"){
      //     txn_NonSelect.push(val['0|txn_id|Txn_id'])
      //   }
      // }
    }
  });

  return { txn_NonSelect, txn_Noneditable };
};

export const nonTxnEditConsolidate = (data) => {
  var txn_Noneditable = [];
  data.map((val, index) => {
    for (var key in val) {
      if (key == "0|is_error|is_error") {
        if (val[key] == 2 || val[key] == 3 || val[key] == 99) {
          txn_Noneditable.push(val["0|txn_id|Txn_id"]);
        }
      }
    }
  });

  return txn_Noneditable;
};

export const filterData = (data) => {
  var txnFilterData = [];
  data.map((val, index) => {
    for (var key in val) {
      if (key == "is_error") {
        if (val[key] != null && val[key] != 0) {
          txnFilterData.push(val);
        }
      }
    }
  });

  return txnFilterData;
};

export const makeTableData = (data) => {
  var dataNew = [],
    pipe = "";
  for (var key in data) {
    if (key != "txn_id" && key != "is_error") {
      var n = key.toString().includes("instance", 0);
      if (n == false) {
        pipe = key.indexOf("|");
        dataNew.push({
          index: key.substring(0, pipe),
          key: key,
          val: data[key],
        });
      }
    }
  }
  return dataNew;
};

export const makeItemTableData = (data) => {
  var dataNew = [],
    pipe = "";
  for (var key in data) {
    if (key != "txn_id" && key != "item_txn_id") {
      var n = key.toString().includes("instance", 0);
      if (n == false) {
        pipe = key.indexOf("|");
        dataNew.push({
          index: key.substring(0, pipe),
          key: key,
          val: data[key],
        });
      }
    }
  }
  return dataNew;
};

export const sortTableData = (dataNew) => {
  var sortA = dataNew.sort(function (a, b) {
    if (a.index != "" && b.index != "") {
      if (parseInt(a.index) > parseInt(b.index)) {
        return 1;
      } else {
        return -1;
      }
    }
  });
  return sortA;
};

export const makeMapData = (sortA) => {
  var newArrayData = [],
    indexPipe = "",
    indexPipeFirst = "",
    arrayData = [],
    obj = {};

  sortA.map((val, index) => {
    newArrayData.push(val.key);
    indexPipe = val.key.lastIndexOf("|");
    indexPipeFirst = val.key.indexOf("|");

    arrayData.push(val.key.substring(indexPipeFirst + 1, indexPipe));
  });
  obj = { newArrayData: newArrayData, arrayData: arrayData };
  return obj;
};

export const fetchColumns = (data) => {
  let dynamic = [];
  for (var key in data) {
    dynamic.push({
      dataField: key,
      text: key,
    });
  }
  return dynamic;
};

export const makeChartData = (chartMsg) => {
  var count = [],
    fail = [],
    pass = [],
    state = [];
  chartMsg.map((val, index) => {
    count.push(val.States_count[0].count);
    fail.push(val.States_count[0].fail);
    pass.push(val.States_count[0].pass);
    state.push(val.States_count[0].state);
  });

  var data = {
    labels: state,
    datasets: [
      {
        label: "Failed Invoices",
        data: fail,
        backgroundColor: "#DE002E",
      },
      {
        label: "Passed Invoices",
        data: pass,
        backgroundColor: "#9BD732",
      },
      {
        label: "Total Invoices",
        data: count,
        backgroundColor: "#4F2D7F",
      },
    ],
  };

  return data;
};

export const lineData = (lineMsg) => {
  var gstinnumsarr = [];
  var AssValarr = [];
  var CesValarr = [];
  var CgstValarr = [];
  var IgstValarr = [];
  var SgstValarr = [];
  var StCesValarr = [];
  var TotInvValarr = [];

  lineMsg.map((val, index) => {
    var gstinnums = val.Amount_count[0].gstin;
    gstinnumsarr.push(gstinnums);
    AssValarr.push(val.Amount_count[0][`${gstinnums}`].AssVal);
    CesValarr.push(val.Amount_count[0][`${gstinnums}`].CesVal);
    CgstValarr.push(val.Amount_count[0][`${gstinnums}`].CgstVal);
    IgstValarr.push(val.Amount_count[0][`${gstinnums}`].IgstVal);
    SgstValarr.push(val.Amount_count[0][`${gstinnums}`].SgstVal);
    StCesValarr.push(val.Amount_count[0][`${gstinnums}`].StCesVal);
    TotInvValarr.push(val.Amount_count[0][`${gstinnums}`].TotInvVal);
  });

  // for (let i = 0; i < lineMsg.data.AmountInfo.length; i++) {
  //   var gstinnums = lineMsg.data.AmountInfo[i].Amount_count[0].gstin
  //   var AssVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].AssVal
  //   var CesVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].CesVal
  //   var CgstVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].CgstVal
  //   var IgstVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].IgstVal
  //   var SgstVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].SgstVal
  //   var StCesVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].StCesVal
  //   var TotInvVal = lineMsg.data.AmountInfo[0].Amount_count[0][`${gstinnums}`].TotInvVal

  //   gstinnumsarr.push(val.Amount_count[0].gstin)
  //   AssValarr.push(val.Amount_count[0][`${gstinnums}`].AssVal)
  //   CesValarr.push(val.Amount_count[0][`${gstinnums}`].CesVal)
  //   CgstValarr.push(val.Amount_count[0][`${gstinnums}`].CgstVal)
  //   IgstValarr.push(val.Amount_count[0][`${gstinnums}`].IgstVal)
  //   SgstValarr.push(val.Amount_count[0][`${gstinnums}`].SgstVal)
  //   StCesValarr.push(val.Amount_count[0][`${gstinnums}`].StCesVal)
  //   TotInvValarr.push(val.Amount_count[0][`${gstinnums}`].TotInvVal)

  // }

  var ldata = {
    labels: gstinnumsarr,
    datasets: [
      {
        label: "AssVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#DE002E",
        borderColor: "#DE002E",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "#DE002E",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "",
        pointHoverBorderColor: "#DE002E",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: AssValarr,
      },
      {
        label: "CesVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#C24200",
        borderColor: "#C24200",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#C24200",
        pointHoverBorderColor: "#C24200",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: CesValarr,
      },

      {
        label: "CgstVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#9BD732",
        borderColor: "#9BD732",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#9BD732",
        pointHoverBorderColor: "#9BD732",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: CgstValarr,
      },
      {
        label: "IgstVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#00A7B5",
        borderColor: "#00A7B5",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#00A7B5",
        pointHoverBorderColor: "#00A7B5",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: IgstValarr,
      },
      {
        label: "SgstVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#4F2D7F",
        borderColor: "#4F2D7F",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#4F2D7F",
        pointHoverBorderColor: "#4F2D7F",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: SgstValarr,
      },
      {
        label: "StCesVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#CBC4BC",
        borderColor: "#CBC4BC",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "#CBC4BC",
        pointHoverBorderColor: "#CBC4BC",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: StCesValarr,
      },
      {
        label: "TotInvVal",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgb(153,220,225)",
        borderColor: "rgb(153,220,225)",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgb(153,220,225)",
        pointHoverBorderColor: "rgb(153,220,225)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: TotInvValarr,
      },
    ],
  };
  return ldata;
};

export const validateGstn = (gstin) => {
  const regexPatterns = [
    "[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[Zz1-9A-Ja-j]{1}[0-9a-zA-Z]{1}",
    "[0-9]{4}[A-Z]{3}[0-9]{5}[UO]{1}[N][A-Z0-9]{1}",
    "[0-9]{2}[a-zA-Z]{4}[0-9]{5}[a-zA-Z]{1}[0-9]{1}[Z]{1}[0-9]{1}",
    "[0-9]{4}[a-zA-Z]{3}[0-9]{5}[N][R][0-9a-zA-Z]{1}",
    "[0-9]{2}[a-zA-Z]{4}[a-zA-Z0-9]{1}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[D]{1}[0-9a-zA-Z]{1}",
    "[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[C]{1}[0-9a-zA-Z]{1}",
    "[9][9][0-9]{2}[a-zA-Z]{3}[0-9]{5}[O][S][0-9a-zA-Z]{1}",
  ];

  return regexPatterns.some((pattern) => new RegExp(pattern).test(gstin));
};
